/* eslint-disable no-undef */
// Single source of truth for Fitune Pay country support.
// NOTE: codes must match the backend `region.countryCode` values ('MXN' for Mexico,
// 'BR' for Brazil). If the backend changes an identifier, update it here only.
//
// To add a country:
// 1. Add its code to SUPPORTED_FITUNE_PAY_COUNTRY_CODES (UI visibility).
// 2. Add it to EXPANSION_COUNTRY_CODES while it stays behind the fitune-pay-expansion flag.
// 3. Add its publishable key to getStripeKeyByCountry, plus the gon/ENV wiring in Rails
//    (admin/app_controller.rb + VUE_APP_STRIPE_PUBLISHABLE_KEY_<COUNTRY>).
export const SUPPORTED_FITUNE_PAY_COUNTRY_CODES = ['MXN', 'BR'];

// Countries whose Stripe key is gated behind the fitune-pay-expansion LaunchDarkly flag.
// Mexico is generally available and never gated.
export const EXPANSION_COUNTRY_CODES = ['BR'];

export const isFitunePayCountry = countryCode =>
  SUPPORTED_FITUNE_PAY_COUNTRY_CODES.includes(countryCode);

// Resolves the country-specific Stripe publishable key, or null to fall back to the
// default key. Built lazily because gon is injected by the layout at page load.
export const getStripeKeyByCountry = (countryCode, expansionEnabled) => {
  if (!expansionEnabled && EXPANSION_COUNTRY_CODES.includes(countryCode)) return null;
  const keyByCountry = {
    MXN: gon.stripePublishableKeyMx,
    BR: gon.stripePublishableKeyBr
  };
  return keyByCountry[countryCode] || null;
};
